import React from 'react';

export const ContextModal = React.createContext();